import { TextColor } from "@/components/typography/Typography"
import { Button as WrappedBtn } from "antd"
import classnames from "classnames"
import { CSSProperties, ComponentProps, FC } from "react"
import "./Button.less"

export type ButtonTypes =
  | "primary"
  | "dark-blue"
  | "ghost"
  | "text"
  | "icon"
  | "extra-wide"
  | "table-action"
  | "hero"
  | "block"
  | "pure-text"

type ButtonProps = {
  bordered?: boolean
  btnType?: ButtonTypes
  // btnType?: 'primary' | 'dark-blue' | 'ghost' | 'text' | 'icon' | 'extra-wide' | 'table-action' | 'hero' | 'block' | 'pure-text'
  link?: string
  mirrored?: boolean
  text?: string
  textColor?: TextColor
  style?: CSSProperties
  isIconWhite?: boolean
  isTransparent?: boolean
}
type BtnProps = ComponentProps<typeof WrappedBtn>

const Button: FC<BtnProps & ButtonProps> = ({
  mirrored = false,
  textColor,
  btnType = "primary",
  icon,
  link = "#",
  text,
  bordered,
  children,
  isIconWhite = false,
  isTransparent = false,
  ...props
}) => {
  const btnClasses = classnames({
    "gw-button": true,
    "primary": btnType === "primary",
    "dark-blue": btnType === "dark-blue",
    "ghost": btnType === "ghost",
    "text": btnType === "text",
    "icon": btnType === "icon",
    "table-action": btnType === "table-action",
    "pure-text": btnType === "pure-text",
    "mirrored": mirrored,
    "bordered": bordered === true,
    "extra-wide primary": btnType === "extra-wide",
    "hero-type": btnType === "hero",
    "white-icon": isIconWhite,
    "transparent": isTransparent,
    "text-white": textColor === "white",
    "text-orange": textColor === "orange",
    "text-website-secondary": textColor === "website-secondary",
    [props?.className as string]: true,
  })

  return (
    <WrappedBtn icon={icon} {...props} className={btnClasses}>
      {text ? text : children ? children : null}
    </WrappedBtn>
  )
}

export default Button
